import AuthController from '@/controllers/AuthController';
import { useI18n } from 'vue-i18n';
import NavigationHelper from '@/util/NavigationHelper';
import { useRouter } from 'vue-router';
import { Forms } from '@/enums/Forms';
import ValidationRules from '@/util/ValidationRules';
import { Ref, ref } from 'vue';
import PageHelper from '@/util/PageHelper';
import { AuthResponseStatus } from '@/enums/AuthResponseStatus';
import PolteqButton from '@/components/PolteqButton/PolteqButton.vue';
import PolteqTextField from '@/components/PolteqTextField/PolteqTextField.vue';
import { VForm } from 'vuetify/components';

export default {
  name: 'SignInForm',
  components: {
    PolteqButton,
    PolteqTextField
  },
  computed: {
    NavigationHelper() {
      return NavigationHelper;
    }
  },
  setup() {
    const i18n = useI18n();
    const router = useRouter();
    const rules = ValidationRules.getRules();
    const signInForm = ref() as Ref<VForm>;
    const signIn = async (username: string, password: string) => {
      await signInForm.value.validate();
      if (signInForm.value.isValid) {
        const response = await AuthController.signIn(username, password, window.location.search);
        if (response.status === AuthResponseStatus.FAILED) {
          PageHelper.setNotificationMessage(response);
        } else if (response.accessToken) {
          await NavigationHelper.openForm(router, Forms.SIGN_IN, { code: response.accessToken });
        }
      }
    };
    return {
      i18n,
      router,
      Forms,
      rules,
      signInForm,
      signIn
    };
  },
  data() {
    return {
      username: '',
      password: ''
    };
  }
};
